// Module
var code = "<div class=\"dragItem\">\r\n    <div class=\"deleteContainer\"><button data-id=\"delete\" type=\"button\"></button></div><div data-id=\"dragContent\" class=\"dragContent\"></div><div data-id=\"dragHandle\" class=\"dragHandle\"></div>\r\n</div>";
// Exports
export default code;